// VariableProvider.js
import React, { useState, useContext } from 'react';
import FetchingFreq from '../contexts/FetchingFreq';
import VariableContext from '../contexts/VariableContext';

import config from '../configs/config'; // Adjust the import path as necessary
import axios from 'axios';
import { faL } from '@fortawesome/free-solid-svg-icons';

const FreqProvider = ({ children }) => {
  const {
    setVariables,
    selectedClient,
    setSelectedClient,
    selectedProject,
    setSelectedProject,
    dataGroup,
    setdataGroup,
    projectId,
    setProjectId,
    retrieveBannersFromBackend,
    banners,
    setBanners,
    fetchWeights,
    savedWeightings,
    loading,
    setLoading,
    sdataGroup,
    setSdataGroup,powner
  } = useContext(VariableContext); // Use setVariables from context
  const [frequencyData, setFrequencyData] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [isCrossTab, setisCrossTab] = useState(false);
  const [activePage, setActivePage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [list, setList] = useState([]);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [statements, setStatements] = useState([]);
  const [oeParameters, setOeParameters] = useState({ min: "", max: "" });
  const [selectedBannerIndex, setSelectedBannerIndex] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [sigLetters, setSigLetters] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [nets, setNets] = useState([]);
  const [showFrequencyTable, setShowFrequencyTable] = useState(false); // New state to control table display
  const [selectedVariable, setSelectedVariable] = useState(null);
  const [validationData, setValidationData] = useState(null);
  const [activeTab, setActiveTab] = useState('Scripting');
  const [refreshData, setRefreshData] = useState(false);
  const [selectedBanner, setselectedBanner] = useState([]); // Added filenames state
  const [tempBanner, setTempBanner] = useState({}); // Added filenames state
  const [selectedWeights, setSelectedWeights] = useState([]); // Added filenames state
  const [isTotal, setIsTotal] = useState(true);
  const [crosstabResults, setCrosstabResults] = useState([]); // Store multiple cross-tab results
  const [isPropertiesShow, setIsPropertiesShow] = useState(false);
  const [selectedQuestionKey, setSelectedQuestionKey] = useState(null);


  const handleDVValidation = async (title) => {
    setSelectedTitle(title);
    setSelectedVariable(dataGroup[title]);
    if (activeTab == 'SPSS') {
      setIsLoading(true);
      setLoading(true);

      const varNames = dataGroup[title];

      if (!varNames || varNames.length === 0) {
        setMessage("Variable names not found for the selected title.");
        setIsLoading(false);
        setLoading(false);
        return;
      }

      try {
        const payload = {
          varNames: varNames, // List of variable names to validate
          key: title, // Optional identifier key
          projectId: projectId, // Required to locate correct SPSS file
        };

        const response = await fetch(`${config.API_BASE_URL}/dvpart`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const codeData = await response.json(); // This should be { varName1: [...codes], ... }

        setValidationData(codeData); // Store unique codes in a separate state
        setMessage("Unique codes retrieved for validation.");
      } catch (error) {
        setMessage("Error occurred while fetching unique codes.");
        console.error("DV Error:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    }

  };
  const handleTitleClick = async (title, crosstab = false) => {
    setSelectedTitle(title);
    setisCrossTab(false);
    setIsLoading(true);
    setLoading(true);
    //setFrequencyData(qgroupEntry);
    const varNames = dataGroup[title]?.varName;
    //const varNames = dataList[title]?.varName;
    if (!varNames || varNames.length === 0) {
      setMessage("Variable names not found for the selected title.");
      setLoading(false);
      return;
    }

    //setSelectedVariable(dataList[title]);
    setSelectedVariable(dataGroup[title]);

    // Check if the data already exists in the cache and refresh is not required
    const varData = dataGroup[title];
    if (isPropertiesShow)
    {
      setdataGroup((prev) => ({ ...prev, [selectedTitle]: selectedVariable }));
      setNets([]);

    }
    if (!isPropertiesShow) {

      try {
        const payload = {
          varNames: dataGroup[title],
          //varNames: dataList[title],
          key: title,
          selectedWeights: selectedWeights, // Include selectedWeights in the payload
          selectedBanner: selectedBanner, // Include selectedBanner in the payload
          projectId: projectId,
          refreshData: refreshData,
          user: powner
        };

        //const response = await fetch(`${config.API_BASE_URL}/frequency`, {
        const response = await fetch(`${config.API_BASE_URL}/Dashboardfrequency`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
          setIsLoading(false);
          setLoading(false);
        }
        const data = await response.json();
        //setFrequencyData(data.frequency_data); // Store frequency data in state
        setFrequencyData(data); // Store frequency data in state
        setCrosstabResults(prevResults => [...(prevResults || []), data]);
        // Update the dataList with the fetched data for future reference, specifically under the selected banner
        //varData.frequencyData = varData.frequencyData || {}; // Ensure the frequencyData object exists
        //varData.frequencyData[selectedBanner?.name] = data.freq_table; // Store fetched data for this banner

        setShowFrequencyTable(true);
        setMessage("Frequency data retrieved successfully.");
        setIsLoading(false);
        setLoading(false);
      } catch (error) {
        setMessage("An error occurred while fetching frequency data.");
        setIsLoading(false);
        setLoading(false);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    }
    else {
      setLoading(false);
      setIsLoading(false);
    }
  };
  const getAlphabeticIdentifier = (index) => {
    let identifier = "";
    while (index >= 0) {
      identifier = String.fromCharCode((index % 26) + 65) + identifier;
      index = Math.floor(index / 26) - 1;
    }
    return identifier;
  };

  const handleSelectionChange = (itemName, itemProperties, bannerSave = false, parentId = null) => {
    let newRows = [];
    // 🚨 HARD STOP: drag / preview / generate
    // if (bannerSave !== true) {
    //   setSelectedItem({ [itemName]: itemProperties });
    //   return;
    // }
    // Determine current letter index based on selected banner rows (if available)
    let index = 0;
    if (banners && selectedBannerIndex !== null) {
      index = banners[selectedBannerIndex]?.rows?.length || 0;
    }

    if (itemProperties.type === "SingleResponse") {

      const variableName = itemName;
      let valueLabels = itemProperties.valueLabels;
      if (!valueLabels) {
        itemProperties.values.forEach((v) =>
        valueLabels = { ...valueLabels, [v['index']]: v['title'] || v['index'] }
         );
      }
      newRows = Object.keys(valueLabels).map((key) => {
        const row = {
          headerText: variableName,
          text: valueLabels[key],
          letter: getAlphabeticIdentifier(index),
          logic: `${variableName}=${Math.round(Number(key))}`,
        };
        index++; // increment for next item
        return row;
      });

      if (itemProperties.Nets) {
        itemProperties.Nets.forEach((net) => {
          const netIndices = net.indices.join(",");
          newRows.push({
            headerText: variableName,
            text: `NET - ${net.label}`,
            letter: getAlphabeticIdentifier(index),
            logic: `${variableName} in (${netIndices})`,
          });
          index++; // increment for next net
        });
      }
    } else if (itemProperties.type === "Multiple2DGrid") {

      const variableName = itemName;
      const subVariables = itemProperties.Rows;
      const subVarNames = itemProperties.varName;

      newRows = subVariables.map((subVar) => {
        const logicVar = subVarNames.find((x) => x.row === subVar.index);
        const row = {
          headerText: variableName,
          text: subVar.title,
          letter: getAlphabeticIdentifier(index),
          logic: `${logicVar?.Name}=1`,
        };
        index++;
        return row;
      });

      if (itemProperties.Nets) {
        itemProperties.Nets.forEach((net) => {
          const netVar = subVarNames
            .filter((x) => net.indices.includes(x.row))
            .map((x) => `${x.Name}=1`);
          const netLogic = netVar.join(" or ");
          newRows.push({
            headerText: variableName,
            text: `NET - ${net.label}`,
            letter: getAlphabeticIdentifier(index),
            logic: netLogic,
          });
          index++;
        });
      }
    }

    if (newRows.length > 0) {
      if (activePage=="crosstab")
      {
if (parentId != null) {
            const newRowsnested = [];
            newRowsnested.push(tempBanner.rows[0]);
            tempBanner.rows.forEach((row, idx) => {
              newRows.forEach((nrow) => {
                if (row.headerText == parentId) {
                  const newrow = {
                    headerText: '',
                    text: '',
                    letter: '',
                    logic: ''
                  };
                  newrow.logic = row.logic + ' and ' + nrow.logic;
                  newrow.text = row.text + '/' + nrow.text;
                  newrow.headerText = row.headerText + '*' + nrow.headerText;
                  newRowsnested.push(newrow);
                }
              })
            });
            const updatedBanners = {
              ...tempBanner,
              rows: [...newRowsnested],
            };
            setTempBanner(updatedBanners);
            setselectedBanner(updatedBanners);
          }

          else {
            const updatedBanners = {
              ...tempBanner,
              rows: [...tempBanner.rows, ...newRows],
            };
            setTempBanner(updatedBanners);
            setselectedBanner(updatedBanners);

          }
      }
      else
      {
        if (banners && selectedBannerIndex !== null) {
                const updatedBanners = banners.map((banner, index) => {
                    if (index === selectedBannerIndex) {
                        return {
                            ...banner,
                            rows: [...banner.rows, ...newRows]
                        };
                    }
                    return banner;
                });
                setBanners(updatedBanners);
            }
             else {
                const newBanner = {
                    name: `Banner ${banners && banners.length + 1 || 1}`,
                    rows:[
                        {
                          headerText: "Total",
                          text: "Total",
                          letter: "A",
                          logic: "ALL"
                        },
                        ...newRows
                      ],
                    minbase: '',  // Initialize minbase
            lowbase: '',   // Initialize lowbase
            minbaseSymbol: '**',  // Initialize minbase
            lowbaseSymbol: '*',   // Initialize lowbase
            isTotal: true,   // Initialize lowbase
            isCompliment:false
                };
                setBanners([...(banners || []), newBanner]);
            }
      }}
      


    setSelectedItem({ [itemName]: itemProperties });
  };
  const handleAllTitlesClick = async () => {
    setIsLoading(true);
    setMessage("Processing all variables...");

    const titles = Object.keys(dataGroup);
    //const titles = Object.keys(dataList);
    const allFrequencyData = {};

    for (const title of titles) {
      //if(dataList[title]?.type && dataList[title].type!='Numeric' && dataList[title].type!='String')
      if (
        dataGroup[title]?.type &&
        dataGroup[title].type != "Numeric" &&
        dataGroup[title].type != "String"
      ) {
        const frequencyData = await handleTitleClick(title, false);
        if (frequencyData) {
          //dataList[title].frequencyData = frequencyData;
        }
      }
    }

    // Send all dataList to the backend for saving
    await saveAllDataListToBackend(dataGroup);
    //await saveAllDataListToBackend(dataList);

    setIsLoading(false);
    setMessage("All variables processed and data saved successfully.");
  };

  const saveAllDataListToBackend = async (dataGroup) => {
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/save_all_data_list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ projectId: projectId, dataList: dataGroup }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setMessage("All dataList saved successfully.");
    } catch (error) {
      setMessage("An error occurred while saving dataList.");
    }
  };
  const saveAllChangesToBackend = async (dataGroup) => {
    setLoading(true); // Start loading indicator
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/save_all_data_list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ projectId: projectId, dataList: dataGroup }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setLoading(false); // Start loading indicator
      setMessage("All dataList saved successfully.");
    } catch (error) {
      setLoading(false); // Start loading indicator
      setMessage("An error occurred while saving dataList.");
    }
  };


  const addQuestion = (selectedQuestionKey = null) => {
    // Add safety check for sdataGroup
    if (!sdataGroup || typeof sdataGroup !== "object") {
      console.warn(
        "sdataGroup is not available, initializing empty data group"
      );

      // Create first question if no data exists
      const firstQuestion = {
        Question_number: "Q1",
        Qtitle: "",
        instructions: "",
        rows: [],
        columns: [],
        rowsRandomisation: false,
        columnsRandomisation: false,
        rowsRotation: false,
        columnsRotation: false,
        alphabeticalOrder: false,
        removeTab: false,
        _order: 0,
      };

      setSdataGroup({ 0: firstQuestion }); // Use "0" as string key
      setRows([{ id: "r1", text: "" }]);
      setColumns([]);
      setSelectedTitle("0");
      setSelectedVariable(firstQuestion);
      setIsModalOpen(true);
      return;
    }

    // Find the highest existing numeric key and add 1 to it
    const numericKeys = Object.keys(sdataGroup)
      .filter((key) => /^\d+$/.test(key)) // Only numeric keys
      .map((key) => parseInt(key));

    const highestKey = numericKeys.length > 0 ? Math.max(...numericKeys) : -1;
    const nextKey = String(highestKey + 1); // Convert to string

    console.log("Adding question with:", {
      nextKey,
      numericKeys,
      highestKey,
      dataGroupKeys: Object.keys(sdataGroup),
    });

    // Create the new question data
    const newQuestion = {
      Question_number: `Q${nextKey}`, // Question_number can still be Q1, Q2, etc.
      Qtitle: "",
      instructions: "",
      rows: [],
      columns: [],
      statements: [],
      rowsRandomisation: false,
      columnsRandomisation: false,
      rowsRotation: false,
      columnsRotation: false,
      alphabeticalOrder: false,
      removeTab: false,
      _order: 0, // Will be updated below
    };

    // Get all sorted entries
    const sortedEntries = Object.entries(sdataGroup).sort((a, b) => {
      const orderA = a[1]._order !== undefined ? a[1]._order : 0;
      const orderB = b[1]._order !== undefined ? b[1]._order : 0;
      return orderA - orderB;
    });

    // Filter out removed tabs to get visible entries
    const visibleEntries = sortedEntries.filter(
      ([_, qgroupEntry]) => !qgroupEntry.removeTab
    );

    let insertPosition = visibleEntries.length; // Default: add at the end

    // If a question is selected, find its position and insert after it
    if (selectedQuestionKey) {
      const selectedIndex = visibleEntries.findIndex(
        ([key, _]) => key === selectedQuestionKey
      );

      if (selectedIndex !== -1) {
        insertPosition = selectedIndex + 1;
        console.log(
          `Inserting after ${selectedQuestionKey} at position ${insertPosition}`
        );
      }
    }

    // Create new data structure with updated orders
    const updatedData = {};

    // Add entries before the insert position with their current order
    visibleEntries.slice(0, insertPosition).forEach(([key, value], index) => {
      updatedData[key] = { ...value, _order: index };
    });

    // Add the new question at the insert position
    newQuestion._order = insertPosition;
    updatedData[nextKey] = newQuestion;

    // Add entries after the insert position with incremented order
    visibleEntries.slice(insertPosition).forEach(([key, value], index) => {
      updatedData[key] = { ...value, _order: insertPosition + 1 + index };
    });

    // Add back any removed entries at the end
    const removedEntries = sortedEntries.filter(
      ([_, qgroupEntry]) => qgroupEntry.removeTab
    );
    removedEntries.forEach(([key, value], index) => {
      updatedData[key] = {
        ...value,
        _order: visibleEntries.length + 1 + index,
      };
    });

    console.log("New question data:", newQuestion);
    console.log("Updated dataGroup keys:", Object.keys(updatedData));
    console.log(
      "Order after insertion:",
      Object.entries(updatedData).map(([key, val]) => ({
        key,
        order: val._order,
      }))
    );

    // Set the new dataGroup
    setSdataGroup(updatedData);

    // Set the rows and columns
    setRows([{ id: "r1", text: "" }]);
    setColumns([]);

    // Set the selected title and variable
    setSelectedTitle(nextKey);
    setSelectedVariable(newQuestion);

    console.log("Immediately after setting state:", {
      nextKey,
      selectedTitle: nextKey,
      selectedVariable: newQuestion,
    });

    // Open the modal
    setIsModalOpen(true);
  };

  return (
    <FetchingFreq.Provider
      value={{
        handleTitleClick,
        activePage,
        handleAllTitlesClick,
        setActivePage,
        sigLetters,
        setSigLetters,
        handleSelectionChange,
        selectedBannerIndex,
        setSelectedBannerIndex,
        selectedItem,
        setSelectedItem,
        refreshData,
        setRefreshData,
        selectedBanner,
        setselectedBanner,
        selectedWeights,
        setSelectedWeights,
        selectedTitle,
        setSelectedTitle,
        selectedVariable,
        setSelectedVariable,
        loading,
        setLoading,
        isModalOpen,
        setIsModalOpen,
        rows,
        setRows,
        columns,
        setColumns,
        addQuestion,
        list,
        setList,
        isTotal,
        setIsTotal,
        handleDVValidation,
        validationData,
        setValidationData,
        saveAllChangesToBackend,
        sdataGroup,
        setSdataGroup,
        oeParameters,
        setOeParameters,
        statements,
        setStatements,
        selectedQuestionKey,
        setSelectedQuestionKey,
        activeTab, setActiveTab, isPropertiesShow, setIsPropertiesShow, crosstabResults, setCrosstabResults,nets, setNets,
        frequencyData, setFrequencyData
      }}
    >
      {children}
    </FetchingFreq.Provider>
  );
};

export default FreqProvider;
